import SinglePageCheckout from "./single-page/single-page"

const SuraasaPlusPayment = () => {
  // const [searchParams] = useSearchParams()

  // const variant = searchParams.get("variant") || "single-page"

  // if (variant === "multi-page") return <MultiPageCheckout />
  return <SinglePageCheckout />
}

export default SuraasaPlusPayment
